export default "__VITE_ASSET__CeN3mmLY__"